export const TENANT_ADMIN_ROLE = 'TENANT_ADMIN';

export const FINANCE_COMMISSION_POLICY_READ = 'finance.commission_policy.read';
export const FINANCE_COMMISSION_POLICY_WRITE = 'finance.commission_policy.write';

export function canAccessOrganizationSettings(roles: readonly string[]): boolean {
  return roles.includes(TENANT_ADMIN_ROLE);
}

export function canViewOrganizationCommissionPolicy(roles: readonly string[]): boolean {
  return roles.includes(FINANCE_COMMISSION_POLICY_READ);
}

export function canEditOrganizationCommissionPolicy(roles: readonly string[]): boolean {
  return roles.includes(FINANCE_COMMISSION_POLICY_WRITE);
}

export function canEnterOrganizationSettings(roles: readonly string[]): boolean {
  return canAccessOrganizationSettings(roles) || canViewOrganizationCommissionPolicy(roles);
}
